import React from "react";
import { Button, Modal } from "react-bootstrap";
import CloseBtn from "../CloseBtn";

const DeleteModal = ({
  show,
  onHide,
  message,
  confirmDelete,
  title,
  onExited,
  onCancel,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered onExited={onExited}>
      <CloseBtn onClick={onHide} color="#bf352b" />
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body dangerouslySetInnerHTML={{ __html: message }} />
      {/* {message} */}
      {/* </Modal.Body> */}
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="danger" onClick={confirmDelete}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;
